import { defineStore } from "pinia";
import { impalaApi } from "@/main";
import JWTDecode from "jwt-decode";
import { clientObject, JWTToken } from "@/interfaces";

export const useClientStore = defineStore("clientStore", {
  state: () => ({
    clientData: undefined as clientObject | undefined,
    clientLoading: false,
    userToken: localStorage.getItem("token"),
    pageLoading: false,
    medicalTests: [],
    medicalTestsResult: null,
  }),
  getters: {
    loggedIn: (state) => {
      if (state.userToken) {
        return JWTDecode<JWTToken>(state.userToken)?.clientId;
      } else return false;
    },
    isTestsEnabled: (state) => {
      return (
        state.userToken &&
        ["2xKsYgmRKAMOeGXHR2YXGgmqPHx"].includes(
          JWTDecode<JWTToken>(state.userToken)?.clientId,
        )
      );
    },
  },
  actions: {
    async loadUserData() {
      try {
        this.clientLoading = true;
        const token = this.userToken;
        if (token == null) return;
        const clientId = JWTDecode<JWTToken>(token)?.clientId;
        const { data } = await impalaApi.get(
          `/client-dashboard/client/${clientId}`,
        );
        this.clientData = data;
        return data as clientObject;
      } catch (error) {
        console.error(error);
        return error;
      } finally {
        this.clientLoading = false;
      }
    },
    async loadMedicalTests() {
      if (!this.isTestsEnabled) return;

      try {
        this.pageLoading = true;
        const token = this.userToken;
        if (token == null) return;
        const clientId = JWTDecode<JWTToken>(token)?.clientId;
        const { data } = await impalaApi.get(
          `/client-dashboard/client/${clientId}/test`,
        );
        this.medicalTests = data;
      } catch (error) {
        console.error(error);
        return error;
      } finally {
        this.pageLoading = false;
      }
    },
    logoutUser() {
      localStorage.removeItem("token");
      this.userToken = null;
      this.clientData = undefined;
    },
    async getTestResults(testId: string) {
      if (!this.isTestsEnabled) return;

      try {
        this.pageLoading = true;
        const token = this.userToken;
        if (token == null) return;
        const clientId = JWTDecode<JWTToken>(token)?.clientId;
        const { data } = await impalaApi.get(
          `/client-dashboard/client/${clientId}/test/${testId}`,
        );
        this.medicalTestsResult = data;
      } catch (error) {
        console.error(error);
        return error;
      } finally {
        this.pageLoading = false;
      }
    },
  },
});
